import { render, staticRenderFns } from "./SetBranch.vue?vue&type=template&id=ed7b82c2"
import script from "./SetBranch.vue?vue&type=script&lang=ts"
export * from "./SetBranch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports